export const objectPropsEmptyToNull = (obj) => {
    for (const prop in obj) {
        if (obj.hasOwnProperty(prop) && obj[prop] === '') {
            obj[prop] = null
        }
    }
} 